import React, { Component } from 'react'
import { Layout, Typography, Row, Col, Button, Card, Carousel, message, Icon, Tag } from 'antd';
import moment from 'moment';
const { Meta } = Card;

class PostCard extends Component {
  constructor(props) {
    super(props)
    this.state = {}

    this.gotoPost = this.gotoPost.bind(this)
  }

  componentDidMount() {
    // console.log(this.props)
  }

  gotoPost() {
    // console.log(this.props)
    const { postData } = this.props
    this.props.history.push(`/blog/${postData.slug}`)
  }

  render() {
    const { postData } = this.props

    return (
      <div className="postcard-holder">
        <Card hoverable
          cover={<img alt="" src={postData.image} />} className="post-card" onClick={()=> this.gotoPost()}>
            <Meta title={postData.title} className="title"/>
            <div className="authorinfo">
              <div className="authorimg-holder">
                <img src="/img/user.png" alt="" className="authorimg"/>
              </div>
              <div className="authordetails">
                <h6>{postData.author}</h6>
                <span><Icon type="clock-circle" className="clock-icon" />{moment(postData.created).format('MMM Do')} . {`${postData.readTime} min`} read</span>
              </div>
            </div>
          </Card>
      </div>
    )
  }
}

export default PostCard